import { render } from "./VariableForm.vue?vue&type=template&id=773d7d4e"
import script from "./VariableForm.vue?vue&type=script&lang=js"
export * from "./VariableForm.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__